import {
  Message,
  MessageBox,
  Loading,
} from 'element-ui'

const prefix = 'wcy' //存储空间名称
export default {
  login (user, remember) {
    this.setLocalStorage('remember', remember)
    if (remember) {//记住密码
      this.setLocalStorage('userInfo', user)
      this.setLocalStorage('token', user.token)
    } else {
      this.setSessionStorage('userInfo', user)
      this.setSessionStorage('token', user.token)
    }
  },
  logout () {
    this.removeLocalStorage('userInfo')
    this.removeLocalStorage('token')
    this.removeSessionStorage('userInfo')
    this.removeSessionStorage('token')
    // this.msg('退出成功！',1,() => {})
    window.location.href = '/login'

  },
  isLogin () {
    let remember = this.getLocalStorage('remember')
    var token = remember ? this.getLocalStorage('token') : this.getSessionStorage('token')
    return token ? true : false
  },
  getToken () {
    let remember = this.getLocalStorage('remember')
    var token = remember ? this.getLocalStorage('token') : this.getSessionStorage('token')
    return token
  },
  getUserInfo () {
    let remember = this.getLocalStorage('remember')
    var user = remember ? this.getLocalStorage('userInfo') : this.getSessionStorage('userInfo')
    return user
  },
  //本地存储
  setLocalStorage (name, data) {
    var wcy = JSON.parse(localStorage.getItem(prefix)) || {}
    wcy[name] = data
    wcy = JSON.stringify(wcy)
    localStorage.setItem(prefix, wcy)
  },
  getLocalStorage (name) {
    var data = localStorage.getItem(prefix)
    data = JSON.parse(data)
    if (!data) return null
    return data[name]
  },
  removeLocalStorage (name) {
    var wcy = JSON.parse(localStorage.getItem(prefix)) || {}
    delete wcy[name]
    wcy = JSON.stringify(wcy)
    localStorage.setItem(prefix, wcy)
  },
  clearLocalStorage (name) {
    localStorage.removeItem(prefix)
  },

  //本地临时存储
  setSessionStorage (name, data) {
    var wcy = JSON.parse(sessionStorage.getItem(prefix)) || {}
    wcy[name] = data
    wcy = JSON.stringify(wcy)
    sessionStorage.setItem(prefix, wcy)
  },
  getSessionStorage (name) {
    var data = sessionStorage.getItem(prefix)
    data = JSON.parse(data)
    if (!data) return null
    return data[name]
  },
  removeSessionStorage (name) {
    var wcy = JSON.parse(sessionStorage.getItem(prefix)) || {}
    delete wcy[name]
    wcy = JSON.stringify(wcy)
    sessionStorage.setItem(prefix, wcy)
  },
  clearSessionStorage (name) {
    sessionStorage.removeItem(prefix)
  },

  inArray (element, array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] == element) {
        return true
      }
    }
    return false
  },

  msgIcon (icon) {
    const iconArr = ['info', 'success', 'warning', 'error']
    return iconArr[icon] || 'info'
  },
  /**
   * 消息提示
   * @param {string} title 提示内容
   * @param {int} icon 提示类型，1：成功，2：警告，3：错误，缺省：默认
   */
  msg (title, icon, cb, secound) {
    var params = {
      message: title,
      type: this.msgIcon(icon),
      onClose: function (e) {
        secound = secound || 3000
        if (typeof cb == 'function') {
          setTimeout(function () {
            cb(e)
          }, secound)
        }
      }
    }
    Message(params)
    return

    var params = {}

    if (icon == 1) {
      Message({
        message: title,
        type: 'success'
      })
    } else if (icon == 2) {
      Message({
        message: title,
        type: 'warning'
      })
    } else if (icon == 3) {
      Message.error(title)
    } else {
      Message('这是一条消息提示')
    }
    secound = secound || 3000
    if (typeof cb == 'function') {
      setTimeout(function () {
        cb()
      }, secound)
    }

  },
  alert (title, icon, cb) {
    var params = {
      type: this.msgIcon(icon),
      confirmButtonText: '确定',
    }
    if (typeof cb == 'function') {
      params['callback'] = action => {
        cb(action)
      }
    }
    MessageBox.alert(title, '提示', params)
  },
  confirm (title, icon, cb,cancelCb) {
    var params = {
      type: this.msgIcon(icon),
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    }
    MessageBox.confirm(title, '提示', params).then(action => {
      if (typeof cb == 'function') {
        cb(action)
      }
    }).catch(() => {
      if (typeof cancelCb == 'function') {
        cancelCb()
      }
    })
  },
  loading (title) {

    var params = {
      lock: true,
      text: title||'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    }
    return Loading.service(params)
  },
  //通过Date对象返回年月日时分秒
  formatDate (date) {
    //如果没有传入date，则返回当前时间
    if (!date) {
      date = new Date()
    }
    if (typeof date == 'number') {
      date = new Date(date * 1000)
    }
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
  },
  dateYMD (date) {
    if (!date) {
      date = new Date()
    }
    if (typeof date == 'number') {
      date = new Date(date * 1000)
    }
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()

  }

}



// WEBPACK FOOTER //
// ./src/utils/function.js